/**
 * Fetches all facilities, open or closed.
 */
export function fetchAll(test = false) {
  // using thunk middleware, so we return a function
  return (dispatch) => {
    // make the call
    return dispatch({
      type: 'FETCH_FACILITIES_ALL',
      payload: {
        request: {
          method: 'get',
          url: `/facilities`,
        },
      },
    }).then((response) => {
      return response;
    });
  };
}

/**
 * Fetches all open facilities.
 */
export function fetchOpen(test = false) {
  // using thunk middleware, so we return a function
  return (dispatch) => {
    // make the call
    return dispatch({
      type: 'FETCH_FACILITIES_OPEN',
      payload: {
        request: {
          method: 'get',
          url: `/facilities?open=true`,
        },
      },
    }).then((response) => {
      return response;
    });
  };
}

/**
 * Fetches a single facility by ID.
 */
export function fetchById(facilityId, test = false) {
  // using thunk middleware, so we return a function
  return (dispatch) => {
    // make the call
    return dispatch({
      type: 'FETCH_FACILITY',
      payload: {
        request: {
          method: 'get',
          url: `/facilities/${facilityId}`,
        },
      },
    }).then((response) => {
      return response;
    });
  };
}

/**
 * Fetches all services for a facility.
 */
export function fetchServices(facilityId, start, end) {
  // using thunk middleware, so we return a function
  return (dispatch) => {
    // build the query parameters
    var params = `?start=${start}&end=${end}`;

    // make the call
    return dispatch({
      type: 'FETCH_FACILITY_SERVICES',
      payload: {
        request: {
          method: 'get',
          url: `/facilities/${facilityId}/services` + params,
        },
      },
    }).then((response) => {
      return response;
    });
  };
}

/**
 * Fetches quotes for a reservation. Note that services is a comma-separated
 * list of service IDs retrieved from fetchServices().
 */
export function fetchQuotes(
  facilityId,
  start,
  end,
  customerId = null,
  services = null,
  fppRedeemed = 0,
) {
  // using thunk middleware, so we return a function
  return (dispatch) => {
    // build the query parameters
    var params = `?start=${start}&end=${end}`;
    if (customerId) {
      params += `&customerId=${customerId}`;
      params += `&fppRedeemed=${fppRedeemed}`;
    }
    if (services) {
      // need a comma-separated list of IDs
      var list = '';
      for (var i = 0; i < services.length; i++) {
        if (list.length > 0) {
          list += ',';
        }
        list += String(services[i].id);
      }
      params += `&services=${list}`;
    }

    // make the call
    return dispatch({
      type: 'FETCH_FACILITY_QUOTES',
      payload: {
        request: {
          method: 'get',
          url: `/facilities/${facilityId}/quotes` + params,
        },
      },
    }).then((response) => {
      return response;
    });
  };
}
